import Vue from 'vue'
import Vuex from 'vuex'
// import db from '@/utils/localstorage' //导入持久化缓存工具
// import config from '../utils/config.js'
import app from "./modules/app"
import permission from './modules/permission'
import getters from './getters'
import user from './modules/user'

Vue.use(Vuex);
// export default new Vuex.Store({
//     state: {
//         isDev:process.env.NODE_ENV === 'development', //是否为开发模式
//         isMute: false,
//         isWaring:false,
//         isLoop:true,//循环播放
//         token:db.get('token')|| '',
//         bjList:db.get('bjList') || [], //报警信息存储
//         userInfo:db.get('userInfo')||null,
//         showFire:false,
//         mapList:{},//存放码表,
//         bimStaus:false,
//         config:config,
//         bimUrl:'',
//         jjList:[], // 接警菜单
//         compList:[],
//         showbjmode:false,
//         noPolice:["e6b0c169701e463eb9cb78facfbc742f"],
//         weihutime:{},
//         alarmDtItem:{},// 实时处理的信息
//         inUrl:'',
//         videoType:['MP4','AVI','FLV','MOV'], // 视频类型
//         pictureType:['PNG','JPG','JPEG','GIF'] // 图片类型
//     },
//     mutations: {
//         isWeihu(state,data){
//             // console.log(data)
//             if(data.starttime&&data.endtime){
//                 state.weihutime = data
//             }else{
//                 state.weihutime={}
//             }
//         },
//         DETAILALRAM(state,data){
//             console.log(data)
//             state.alarmDtItem = data
//         },
//         bimchange(state,data){
//             state.bimStaus = !state.bimStaus
//             state.bimUrl = data ? data :''
//         },
//         SHOWBJlIST(state,data){
//             state.showbjmode = data 
//         },
//         SAVECOMP(state,data){
//             if(data){
//                 state.compList = data
//             }
//             console.log('当前能看到单位个数:'+state.compList.length)
//         },
//         swtichLoop(state){
//             state.isLoop = !state.isLoop
//         },
//         addMapList(state,obj){
//             state.mapList[obj.key] = obj.value
//         },
//         switchMute(state) {
//             state.isMute = !state.isMute
//             if(!state.isWaring){
//                 document.getElementById('warningMp3').muted = true;
//             }else{
//                 document.getElementById('warningMp3').muted = state.isMute
//             }
           
//         },
//         swithWaring(state,status){
//           state.isWaring = status
//             if(!status){
//                 document.getElementById('warningMp3').muted = true;
//             }else{
//                 document.getElementById('warningMp3').muted = state.isMute
//             }
//                     console.log(state.isWaring)
//         },
//         addBjList(state,data){
//             if(data){
//                 if(state.bjList.length>300){
//                     state.bjList.pop()
//                 }
//                 state.bjList.unshift(data)
//                 db.save('bjList',state.bjList)
//             }
//         },
//         // 一键处理修改渲染
//         detailAll(state,data){
//             var arr = state.bjList
//                arr.map((item,index)=>{
//                    data.map((it,idx)=>{
//                         if(it.id===item.id){
//                             console.log(it)
//                             var obj = {...item,...it}
//                             console.log(obj)
//                             arr.splice(index,1,obj)
//                         }
//                    })
//                })
//                console.log(arr)
//                state.bjList = arr
//                db.save('bjList',state.bjList)

                
//         },
        
//         editBjList(state,data){
               
//             if(data){
//                 var arr = state.bjList
//                 arr.map((item,index)=>{
//                     if(item.id===data.id){
//                         console.log(true)
//                         arr.splice(index,1,data)
//                     }
//                 })
//                 state.bjList = arr
//                 db.save('bjList',state.bjList)

//             }
//         },


//                // 添加接警
//         addJJList(state,data){
//             if(data){
//                 state.jjList.unshift(data)
//                 // db.save('jjList',state.jjList)
//             }
//         },
//         clearJJList(state){
//             state.jjList=[]
//         },


//         saveBjList(state,data){
//             state.bjList = data
//             db.save('bjList',data)
//         },
//         saveUser(state,data,isSave){ //存储用户信息
//             if(data){
//                 state.userInfo = data
//                 state.token = data.token
//                 db.save('userInfo',data)
//                 db.save('token',data.token)
//             }
//         },
//         clearUser(state){
//             state.userInfo = null
//             state.token = ''
//             db.remove('userInfo')
//             db.remove('token')
//             db.remove('bjList')
//             db.remove('company')
//         }
//     },
//     actions: {},
//     modules: {}
// })
const store = new Vuex.Store({
    ...app,
    modules:{
        user,
        permission
    },
    getters
})

export default store